export enum PayloadState {
  rejected = 'rejected',
  fulfilled = 'fulfilled',
  pending = 'pending',
}
